(function() {
  var DialogController,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  DialogController = App.loadClass('core::Angular/DialogController');

  exports.IngredionDialogController = (function(superClass) {
    extend(IngredionDialogController, superClass);

    function IngredionDialogController(state, scope, transitions, modalInstance, http, survey) {
      var ref;
      this.state = state;
      this.scope = scope;
      this.transitions = transitions;
      this.modalInstance = modalInstance;
      this.http = http;
      this.survey = survey;
      this.save = bind(this.save, this);
      IngredionDialogController.__super__.constructor.call(this, this.scope, this.transitions, this.modalInstance);
      this.scope.title = 'Ingredion';
      this.scope.editing = true;
      this.blank_survey = {
        for_ingredion: null,
        nearby_corn: null,
        corn_is_gmo: null,
        nearby_fields: [
          {
            direction: null,
            distance: null
          }
        ]
      };
      this.scope.survey = (ref = this.survey) != null ? ref : this.blank_survey;
      this.scope.directions = ['North', 'Northeast', 'East', 'Southeast', 'South', 'Southwest', 'West', 'Northwest'];
      this.scope.distances = ['160 feet or less', '161 to 600 feet', 'More than 600 feet'];
      this.scope.$watch('survey.for_ingredion', (function(_this) {
        return function(val) {
          if (_this.scope.editing && !val) {
            return _this.scope.survey.nearby_corn = null;
          }
        };
      })(this));
      this.scope.$watch('survey.nearby_corn', (function(_this) {
        return function(val) {
          if (_this.scope.editing && !val) {
            return _this.scope.survey.corn_is_gmo = null;
          }
        };
      })(this));
      this.scope.$watch('survey.corn_is_gmo', (function(_this) {
        return function(val) {
          if (_this.scope.editing && !val) {
            return _this.scope.survey.nearby_fields = [
              {
                distance: null,
                direction: null
              }
            ];
          }
        };
      })(this));
      this.scope.addNearbyField = (function(_this) {
        return function() {
          return _this.scope.survey.nearby_fields.push({
            direction: null,
            distance: null
          });
        };
      })(this);
      this.scope.removeNearbyField = (function(_this) {
        return function(field) {
          if (_this.scope.survey.nearby_fields.length === 1) {
            return _this.scope.survey.nearby_fields[0] = {
              distance: null,
              direction: null
            };
          }
          return _.pull(_this.scope.survey.nearby_fields, field);
        };
      })(this);
    }

    IngredionDialogController.prototype.save = function(pretending) {
      return this.http.post('backend/grower/maps-conversion/validate-ingredion-survey', {
        survey: this.scope.survey
      }).then((function(_this) {
        return function(response) {
          if (!pretending) {
            return _this.modalInstance.close(_this.scope.survey);
          }
        };
      })(this));
    };

    return IngredionDialogController;

  })(DialogController);

}).call(this);
